import { render, staticRenderFns } from "./documentSeal.vue?vue&type=template&id=119a6c40&scoped=true"
import script from "./documentSeal.vue?vue&type=script&lang=js"
export * from "./documentSeal.vue?vue&type=script&lang=js"
import style0 from "./documentSeal.vue?vue&type=style&index=0&id=119a6c40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a6c40",
  null
  
)

export default component.exports